import { Component, EventEmitter, inject, Output } from '@angular/core';
import { FormBuilder, FormControl, Validators, FormArray, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from 'src/app/_service/data.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-kpidata-export',
  templateUrl: './kpidata-export.modal.html',
  styleUrls: ['./kpidata-export.modal.scss']
})
export class KPIDataExportModal {

  departments: {id: string, name: string}[] = [];

  deptForms: DeptFormsResponse = {};

  file_link: string = "";

  submitting: boolean = false;

  filters = {
    department: null as string | null,  // key of deptForms
    start_date: null as string | null,
    end_date: null as string | null,
    status: 'all' as 'submitted' | 'unsubmitted' | 'all',
    formTypeMap: {} as Record<number, boolean>
  };


  get selectedDeptForms(): DeptForm[] {
    if (!this.filters.department) return [];
    return this.deptForms[this.filters.department] || [];
  }

  constructor(
    public activeModal: NgbActiveModal, 
    private data: DataService,
  ) {

  }


  ngOnInit() {
    this.data.get('kpi_data/init_export').then((res)=>{
      this.departments = res.departments
      this.deptForms = res.dept_forms;
    })
  }


  submit() {
    if(this.submitting) return;
    this.submitting = true;

    // minimal inline validation: if both dates present, ensure start <= end
    const { department, start_date, end_date } = this.filters;
    if (!department) {
      alert('Department is required');
      this.submitting = false;
      return;
    }

    if (!start_date || !end_date) {
      alert('Both Start and End Dates are required');
      this.submitting = false;
      return;
    }

    if (start_date && end_date && start_date > end_date) {
      alert('Start date must be before or equal to end date.');
      this.submitting = false;
      return;
    }
    
    const form_types = Object.entries(this.filters.formTypeMap)
      .filter(([, checked]) => checked)
      .map(([key]) => key);

    if (form_types.length == 0) {
      alert('At least one form type must be selected');
      this.submitting = false;
      return;
    }

    
    const payload: FilterFormValue = {
      department: this.filters.department,
      start_date: this.filters.start_date,
      end_date: this.filters.end_date,
      form_types,
      status: this.filters.status
    };

    this.data.post("kpi_data/create_export", payload).then((res: any) => {
      this.submitting = false;
      
      if(res.success) {
        this.file_link = environment.api_url+'kpi_data/open_export?filename='+res.filename;
        if(res.filename) {
          setTimeout(()=>{
            window.open(this.file_link, '_blank')
          }, 1000)
        }
      }
    })
  }

}


export interface FilterFormValue {
  department: string | null;
  start_date: string | null;  // 'YYYY-MM-DD' or null
  end_date: string | null;
  form_types: string[];       // selected values
  status: 'submitted' | 'unsubmitted' | 'all';
}

export interface DeptForm {
  id: number;
  frequency: string;
}

export type DeptFormsResponse = Record<string, DeptForm[]>;